import React from 'react';
import {observer} from 'mobx-react';
import {action} from 'mobx';
import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';
import {
    FormGroup, FormControl, ControlLabel,
    Form, Row, Col, Checkbox, Button, ButtonToolbar, Alert
} from 'react-bootstrap';
import {injectIntl} from 'react-intl';
import {LinkContainer} from 'react-router-bootstrap';

import AttachmentsForm from '../common_components/attachments/AttachmentsForm';
import {
    customerSegmentCardsAsHTMLOptions, getCardsAsHTMLOptions,
    getCardsFromCustomerSegmentsHTMLSelectedOptions
} from './common/CardsSelectOptionsHelpers'
import ButtonWithConfirmation from "../common_components/ButtonWithConfirmation";
import AITextEditor from '../AITextEditor';


@observer
class CustomerRelationshipsForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: "",
            name: "",
            description: "",
            attach_url: undefined,
            crPurpose: "",
            customerSegments: [],
            relation: "no_relation",
            resultingClientsNumber: 0,


            isEdition: false,
        };

        this.canDeleteCard = props.blockStore.rootStore.authorizationStore.canDeleteCard(props.blockStore.editingCard);

        this.renderSaveOrUpdateButton = this.renderSaveOrUpdateButton.bind(this);
        this.renderCustomerSegmentsSelectOptions = this.renderCustomerSegmentsSelectOptions.bind(this);


        this.handleLabelChange = this.handleLabelChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handlePurposeChange = this.handlePurposeChange.bind(this);
        this.handleCustomerSegmentsChange = this.handleCustomerSegmentsChange.bind(this);
        this.handleRelationChange = this.handleRelationChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleResultingClientsNumberChange = this.handleResultingClientsNumberChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

    }

    render() {
        return (
            <div>
                {this.renderForm()}
            </div>
        );
    }

    renderForm() {

        const {blockStore, intl} = this.props;

        let cancelBtn;

        if (this.props.hideCancelBtn == null) {
            cancelBtn = <Button bsStyle="default" onClick={this.handleCancel}>
                {intl.formatMessage({id: "cancel"})}
            </Button>;
        } else {
            cancelBtn = <div></div>;
        }


        const labelValue = this.state.label.trim() ?
            intl.formatMessage({
                id: this.state.label,
                defaultMessage: " "
            }) : "";

        return (
            <div>

                {this.state.isEdition && (

                    <FormGroup
                        controlId="LabelCRId"
                        validationState={this.validateLabel()}>
                        <Row>
                            <Col xs={12} sm={2}>
                                <ControlLabel> {intl.formatMessage({id: "station"})} </ControlLabel>
                            </Col>
                            <Col xs={12} sm={10}>
                                <FormControl
                                    type="text"
                                    value={labelValue}
                                    placeholder=""
                                    onChange={this.handleLabelChange}
                                    disabled={true}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                )}


                <FormGroup
                    controlId="NameCRId"
                    validationState={this.validateName()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel> {intl.formatMessage({id: "name"})} </ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <FormControl
                                type="text"
                                value={this.state.name}
                                placeholder=""
                                onChange={this.handleNameChange}
                            />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="DescriptionCRId" validationState={this.validateDescription()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel>{intl.formatMessage({id: "description"})}</ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <AITextEditor
                                value={this.state.description}
                                onChange={(value) => this.setState({description: value})}
                                context="El texto con el que estás trabajando es sobre la descripción de relaciones con clientes en un modelo de negocio Canvas. Las relaciones con clientes describen los tipos de relaciones que una empresa establece con segmentos de clientes específicos. Puede incluir asistencia personal, autoservicio, comunidades, co-creación, etc."
                                rows={4}
                                placeholder=""
                            />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="PurposeSelectCRId" validationState={this.validatePurpose()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel>{intl.formatMessage({id: "purpose"})}</ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <FormControl componentClass="textarea"
                                         type="text"
                                         value={this.state.crPurpose}
                                         placeholder=""
                                         onChange={this.handlePurposeChange}/>
                        </Col>
                    </Row>

                </FormGroup>


                <FormGroup controlId="RelationSelectMultipleCRId">
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel>{intl.formatMessage({id: "relation"})}</ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <FormControl componentClass="select"
                                         onChange={this.handleRelationChange}
                                         value={this.state.relation}>
                                <option value="no_relation">{intl.formatMessage({id: "select"})}</option>
                                <option value="get">{intl.formatMessage({id: "get"})}</option>
                                <option value="keep">{intl.formatMessage({id: "keep"})}</option>
                                <option value="grow">{intl.formatMessage({id: "grow"})}</option>
                            </FormControl>
                        </Col>
                    </Row>
                </FormGroup>


                {this.renderCustomerSegmentsSelect()}


                <FormGroup
                    controlId="ResultingClientsNumberCRId"
                    validationState={this.validateTotalCost()}>
                    <Row>
                        <Col xs={12} sm={4}>
                            <ControlLabel> {intl.formatMessage({id: "resulting_clients_number"})} </ControlLabel>
                        </Col>
                        <Col xs={12} sm={8}>
                            <FormControl
                                type="number"
                                value={this.state.resultingClientsNumber}
                                step="1"
                                placeholder=""
                                onChange={this.handleResultingClientsNumberChange}
                            />
                        </Col>
                    </Row>
                </FormGroup>


                <AttachmentsForm attachable={blockStore.editingCard}/>

                <br/>

                <ButtonToolbar className="pull-right">
                    {this.renderSaveOrUpdateButton()}

                    {this.state.isEdition && this.canDeleteCard && (
                        <ButtonWithConfirmation dropdownClassname="bmc-card-delete-button"
                                                confirmationMessage={intl.formatMessage({id: "delete_confirmation_msg"})}
                                                option1Label={intl.formatMessage({id: "delete_confirmation_no"})}
                                                option2Label={intl.formatMessage({id: "delete_confirmation_yes"})}
                                                onOption2Select={this.handleDelete}
                                                dropup>
                            {intl.formatMessage({id: "delete"})}
                        </ButtonWithConfirmation>
                    )}

                    {cancelBtn}
                </ButtonToolbar>

                <div className="clearfix"/>

            </div>
        );
    }

    renderCustomerSegmentsSelect() {
        //const {intl} = this.props;
        return (
            <FormGroup
                controlId="CustomerSegmentsSelectMultiple"
                validationState={this.validateCustomerSegments()}
            >
                <Row>
                    <Col xs={12} sm={4}>
                        <ControlLabel> {this.props.intl.formatMessage({id: "IgbmcBoard-customer_segments"})} </ControlLabel>
                    </Col>
                    <Col xs={12} sm={8}>
                        <Select
                            onChange={this.handleCustomerSegmentsChange}
                            value={getCardsAsHTMLOptions(this.state.customerSegments)} multi
                            placeholder=""
                            options={this.renderCustomerSegmentsSelectOptions()}
                        />
                    </Col>
                </Row>
            </FormGroup>
        );
    }

    renderSaveOrUpdateButton() {

        if (this.state.isEdition) {
            return (
                <Button bsStyle="primary" onClick={this.handleUpdate}>
                    {this.props.intl.formatMessage({id: "save"})}
                </Button>
            )
        } else {
            const buttonMessage = this.props.blockStore.rootStore.stepByStepMode ? "save" : "add";

            return (
                <Button bsStyle="primary" onClick={this.handleSubmit}
                        disabled={!this.state.name && !this.state.description}>
                    {this.props.intl.formatMessage({id: buttonMessage})}
                </Button>
            )
        }


    }

    renderCustomerSegmentsSelectOptions() {
        return customerSegmentCardsAsHTMLOptions(this.props.blockStore);
    }

    handleLabelChange(e) {
        //this.setState({label: e.target.value});
    }

    handleNameChange(e) {
        this.setState({name: e.target.value});
    }

    handlePurposeChange(e) {
        this.setState({crPurpose: e.target.value});
    }

    handleCustomerSegmentsChange(value) {

        const cards = getCardsFromCustomerSegmentsHTMLSelectedOptions(this.props.blockStore, value);

        this.setState({customerSegments: cards});
    }

    handleRelationChange(e) {

        this.setState({relation: e.target.value});
    }

    handleDescriptionChange(e) {

        this.setState({description: e.target.value});
    }


    handleResultingClientsNumberChange(e) {
        this.setState({resultingClientsNumber: e.target.value});

    }


    validateLabel() {

    }

    validateName() {

    }

    validatePurpose() {

    }

    validateCustomerSegments() {

    }

    validateRelation() {

    }

    validateDescription() {

    }


    validateTotalCost() {

    }

    @action
    handleSubmit() {
        const card = this.generateCardFromState();
        this.props.blockStore.addCard(card);
        this.props.blockStore.showBlockModal(false);

        this.resetForm();
    }


    @action
    handleCancel() {
        const {blockStore} = this.props;
        blockStore.hideBlockModal(true);

        this.resetForm();
    }

    @action
    handleUpdate() {
        this.generateCardFromState();

        const {blockStore} = this.props;

        if (blockStore.editingCard.persisted) {
            blockStore.editingCard.update();
            blockStore.showBlockModal(false);
        }
    }


    @action
    handleDelete() {
        this.props.blockStore.editingCard.destroy();
        this.props.blockStore.hideBlockModal(true);

    }


    generateCardFromState() {
        const {editingCard} = this.props.blockStore;

        editingCard.label = this.state.label;
        editingCard.name = this.state.name;
        editingCard.crPurpose = this.state.crPurpose;
        editingCard.customerSegments = this.state.customerSegments;
        editingCard.relation = this.state.relation;
        editingCard.description = this.state.description;
        editingCard.resultingClientsNumber = this.state.resultingClientsNumber;

        return editingCard;
    }

    resetForm() {
        this.setState({
            label: "",
            name: "",
            crPurpose: "",
            customerSegments: [],
            relation: "no_relation",
            description: "",
            attach_url: undefined,
            resultingClientsNumber: 0,

            isEdition: false,

        });
    }


    componentDidMount() {
        this.initFields(this.props.blockStore.editingCard);
    }

    initFields(card) {
        //const card = this.props.blockStore.editingCard;


        this.setState({
            label: card.label,
            name: card.name,
            crPurpose: card.crPurpose,
            customerSegments: card.customerSegments,
            relation: card.relation,
            description: card.description,
            resultingClientsNumber: card.resultingClientsNumber,


            isEdition: card.persisted,

        });
    }


}

export default injectIntl(CustomerRelationshipsForm);